export function getTimeZoneOffsetHours() {
  const offset = new Date().getTimezoneOffset();
  return offset / 60;
}
